export default __webpack_public_path__ + "static/media/q_wdt_c_6.36fcbabc.mp3";